var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9999 15.988C20.3024 15.988 23.7901 12.5022 23.7901 8.20237C23.7901 3.90255 20.3024 0.416748 15.9999 0.416748C11.6974 0.416748 8.20962 3.90255 8.20962 8.20237C8.20962 12.5022 11.6974 15.988 15.9999 15.988ZM31.5804 31.0416L31.5832 31.5834H0.416504L0.419305 31.0416C0.419305 22.9794 7.93277 17.4167 15.9999 17.4167C24.067 17.4167 31.5804 22.9794 31.5804 31.0416Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.3f0a225d6cf77ed4a77607f8782f4683.svg";
export { ForwardRef as ReactComponent };